import { theme, darkTheme } from './theme/themeVariables';

const config = {
  darkMode: true,
  topMenu: true,
  rtl: false,
  theme,
  darkTheme,
  auth0: false,
};

export default config;
